import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { pdf } from '@react-pdf/renderer';
import './Pricing.css';
import ProgramPDF, { ProgramData } from './ProgramPDF';

interface Program extends ProgramData {
  featured?: boolean;
}

const programs: Program[] = [
  {
    id: 1,
    category: 'Contabilidad',
    title: 'Técnico Laboral en Auxiliar Contable',
    description: 'El técnico laboral en Auxiliar Contable y Financiero está en capacidad de asistir al área contable y financiera de empresas públicas o privadas, en el desarrollo de los procesos contables que conlleven a identificar, registrar, seleccionar, procesar, interpretar y conservar la información contable y financiera.',
    objective: 'Formar personal competente para ejecutar tareas básicas y operativas en las áreas financieras y contables de cualquier empresa, manejando el registro, organización y clasificación de documentos, el manejo de software contable, la conciliación bancaria, la elaboración de pólizas y reportes, y la preparación de información para declaraciones tributarias.',
    exitProfile: 'Profesional organizado, detallista y preciso, capaz de apoyar procesos contables, financieros y administrativos, registrando transacciones, gestionando documentos (facturas, comprobantes), elaborando informes básicos y liquidando impuestos, utilizando herramientas manuales y computarizadas.',
    duration: '2 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['Contabilidad', 'Finanzas', 'Software Contable', 'Impuestos', 'NIIF'],
    pensum: [
      'Fundamentos de Contabilidad y Finanzas',
      'Taller de Software Contable y Financiero',
      'Fundamentos de Administración',
      'Nómina y Prestaciones Sociales',
      'TIC',
      'Comunicación Oral y Escrita',
      'Contabilidad I',
      'Taller de Software Contable y Financiero II',
      'Costos',
      'Organización de Archivos y Gestión Documental',
      'Legislación Laboral',
      'Presupuestos',
      'Contabilidad II',
      'Impuestos',
      'Normas Internacionales de Información Financiera (NIIF)',
      'Legislación Tributaria',
      'Análisis Financiero',
      'Creación y Desarrollo de Empresas',
    ],
    complementary: ['Seminarios cada semestre', 'Trabajo de investigación en campo de prácticas'],
    featured: true,
  },
  {
    id: 2,
    category: 'Educación',
    title: 'Técnico Laboral Auxiliar en Primera Infancia',
    description: 'Se enfoca en apoyar el desarrollo integral (cognitivo, socioafectivo, físico y motriz) de niños y niñas de 0 a 6 años, participando en actividades de cuidado, educación, salud y nutrición, trabajando en jardines, guarderías, centros de desarrollo infantil y hogares comunitarios.',
    objective: 'Formar personal cualificado para apoyar el desarrollo integral (físico, cognitivo, social y emocional) de niños y niñas de 0 a 6 años, mediante la implementación de actividades lúdicas, pedagógicas y de cuidado, siguiendo los planes de atención integral y promoviendo sus derechos y bienestar en diversos contextos educativos y familiares.',
    exitProfile: 'Profesional integral, humanista y ético, capaz de acompañar el desarrollo cognitivo, socio-afectivo, físico y motriz de niños hasta los 6 años mediante estrategias lúdicas, pedagógicas y de protección de derechos, fomentando la salud, la nutrición y el bienestar en jardines infantiles, hogares comunitarios o centros de atención.',
    duration: '2 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['Primera Infancia', 'Pedagogía', 'Nutrición', 'Inglés', 'Lúdica'],
    pensum: [
      'Fundamentos Pedagógicos y Didácticos I',
      'Metodología y Cultura de Aprendizaje',
      'Desarrollo de las Competencias o Habilidades Comunicativas',
      'Inglés I',
      'Expresión Artística y Trabajo Manual',
      'Fundamentos Pedagógicos y Didácticos II',
      'Primeros Auxilios y Nutrición I',
      'Inglés II',
      'Competencias Transversales',
      'Administración Educativa',
      'Primeros Auxilios y Nutrición II',
      'Metodología y Cultura de Aprendizaje II',
      'Desarrollo de las Competencias Lógico Matemáticas',
    ],
    complementary: ['Seminarios cada semestre', 'Trabajo de investigación en campo de prácticas'],
  },
  {
    id: 3,
    category: 'Seguridad',
    title: 'Técnico Laboral en Seguridad Ocupacional',
    description: 'El técnico en Seguridad Ocupacional se enfoca en identificar, evaluar y controlar riesgos laborales, promover la prevención de accidentes y enfermedades, y gestionar sistemas de seguridad, aplicando normativas para crear ambientes de trabajo seguros y saludables.',
    objective: 'Prevenir accidentes de trabajo y enfermedades laborales, protegiendo la integridad física y mental de los trabajadores mediante la identificación, evaluación y control de peligros y riesgos en el entorno laboral, fomentando un ambiente de trabajo seguro y saludable y promoviendo el bienestar general de los empleados.',
    exitProfile: 'Profesional capacitado para identificar, evaluar y controlar riesgos laborales, aplicando normativas para diseñar e implementar programas de prevención, liderando equipos, capacitando personal y apoyando en planes de emergencia para proteger la integridad física y mental de los trabajadores.',
    duration: '2 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['SST', 'Riesgos Laborales', 'Prevención', 'Emergencias', 'Normativa'],
    pensum: [
      'Fundamentos de Seguridad y Salud Ocupacional',
      'Saneamiento Básico',
      'Marco Legal en Seguridad y Salud Ocupacional',
      'Protección y Control de Incendios',
      'Primeros Auxilios',
      'TIC',
      'Matriz de Peligros',
      'Planes de Emergencias y Trabajos de Alto Riesgo',
      'Estadísticas Aplicadas',
      'Riesgos Laborales Físicos y Químicos',
      'Enfermedades Laborales y Medicina Preventiva',
      'Planes y Brigada de Emergencia',
      'Gestión del Talento Humano',
      'Seguridad Social',
      'Gestión Ambiental',
      'Prevención y Promoción de la Seguridad y Salud en el Trabajo',
      'Higiene Industrial y Ergonomía',
      'Diseño de Sistemas de Gestión de Seguridad y Salud en el Trabajo',
    ],
    complementary: ['Seminarios cada semestre', 'Trabajo de investigación en campo de prácticas'],
    featured: true,
  },
  {
    id: 4,
    category: 'Administración',
    title: 'Técnico Laboral en Asistencia Administrativa',
    description: 'El Técnico Laboral en Asistente Administrativo puede desempeñarse como recepcionista, asistente de gerencia, secretaria auxiliar contable, soporte administrativo, manejo de archivo, atención al cliente y asistente en coordinación de eventos empresariales.',
    objective: 'Formar un egresado con conocimientos técnicos de los principios y prácticas de Asistente Administrativo y con competencias para desenvolverse sin dificultades en el mundo laboral empresarial.',
    exitProfile: 'Profesional capaz de coordinar actividades del talento humano, contabilizar recursos, producir documentos administrativos, facilitar el servicio a clientes internos y externos, organizar documentos según su ciclo de vida y gestionar eventos que promuevan las relaciones empresariales.',
    duration: '2 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['Administración', 'Archivo', 'Atención al Cliente', 'Logística', 'Gestión'],
    pensum: [
      'Fundamentos de Contabilidad y Finanzas',
      'Taller de Software Contable y Financiero',
      'Fundamentos de Administración',
      'Nómina y Prestaciones Sociales',
      'TIC',
      'Comunicación Oral y Escrita',
      'Contabilidad General',
      'Marketing y Ventas',
      'Costos',
      'Organización de Archivos y Gestión Documental',
      'Legislación Laboral',
      'Presupuestos',
      'Gestión del Talento Humano',
      'Seguridad Ocupacional y Salud en el Trabajo',
      'Compras, Logística y Distribución',
      'Gestión de la Calidad y Servicio al Cliente',
      'Análisis Financiero',
      'Creación y Desarrollo de Empresas',
    ],
    complementary: ['Seminarios cada semestre', 'Trabajo de investigación en campo de prácticas'],
  },
  {
    id: 5,
    category: 'Tecnología',
    title: 'Técnico Laboral en Asistencia y Soporte de Tecnologías de la Información',
    description: 'Forma personal para el mantenimiento, diagnóstico y resolución de problemas en hardware, software y redes. El egresado puede desempeñarse como técnico de soporte, administrador de redes, asistente en seguridad informática o en infraestructura tecnológica, en empresas e instituciones del sector TI.',
    objective: 'Formar y capacitar en el mantenimiento, diagnóstico y resolución de problemas en hardware, software y redes, con una sólida base en tecnologías de la información, enfoque práctico y orientación a la empleabilidad.',
    exitProfile: 'Técnico con interés por la tecnología y la resolución de problemas informáticos, capaz de brindar soluciones técnicas a nivel empresarial e institucional: soporte, redes, seguridad informática e infraestructura tecnológica, con atención al detalle y disposición para el aprendizaje continuo.',
    duration: '3 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['Soporte TI', 'Redes', 'Hardware', 'Software', 'Mantenimiento'],
    pensum: [
      'Inglés',
      'Emprendimiento',
      'Instalación de Equipos',
      'Mantenimiento Preventivo y Correctivo',
      'Reparación de Equipos',
      'TIC',
      'Redes',
      'Soporte Técnico',
    ],
    complementary: ['Seminarios cada semestre', 'Prácticas académicas'],
    featured: true,
  },
  {
    id: 6,
    category: 'Social',
    title: 'Técnico Laboral en Servicio Social y Comunitario',
    description: 'Forma auxiliares capaces de documentar, acompañar y apoyar proyectos de desarrollo social, comunitario y administrativo. El egresado puede desempeñarse en entidades estatales, fundaciones y organismos de derechos humanos, en protección a la familia, infancia, adolescencia y procesos de rehabilitación.',
    objective: 'Desarrollar competencias laborales en la documentación, acompañamiento y apoyo en la ejecución de proyectos de desarrollo social, comunitario y administrativo, que generen impacto en el individuo y la sociedad, con equidad, justicia, derechos humanos, cultura, dignidad y protección del medio ambiente.',
    exitProfile: 'Auxiliar de servicio social y comunitario, capaz de apoyar procesos de protección a la familia, infancia y adolescencia, comunidades terapéuticas y servicios de rehabilitación y resocialización, con reconocimiento y respeto por los derechos humanos.',
    duration: '3 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['Trabajo Social', 'Comunidad', 'Proyectos Sociales', 'Familia', 'Derechos Humanos'],
    pensum: [
      'Psicología General y Evolutiva',
      'Sociología y Dinámica de Grupos',
      'Historia y Contexto del Trabajo Social',
      'Metodología de Intervención en Caso, Grupo y Comunidad',
      'Técnicas de Entrevista y Diagnóstico Social',
      'Gestión y Formulación de Proyectos Sociales',
      'Legislación de Familia, Infancia y Adolescencia',
      'Constitución y Políticas Públicas',
      'Administración y Gestión de Recursos Sociales',
      'Promoción y Prevención en Salud Mental o Comunitaria',
      'Seguridad y Salud en el Trabajo',
      'Emprendimiento',
      'Herramientas Informáticas',
      'Gestión Ambiental',
    ],
    complementary: ['Seminarios cada semestre', 'Prácticas académicas'],
  },
  {
    id: 7,
    category: 'Justicia',
    title: 'Técnico Laboral en Investigador Criminalístico y Judicial',
    description: 'Prepara para apoyar procesos investigativos y judiciales: recolección y análisis de evidencias, cadena de custodia, informes periciales y procedimientos judiciales. El egresado puede trabajar en despachos jurídicos, consultorías forenses, aseguradoras, organismos de control o de forma independiente.',
    objective: 'Adquirir conocimientos fundamentales en técnicas de investigación, recolección y análisis de evidencias, cadena de custodia, elaboración de informes periciales y procedimientos judiciales, con formación en criminalística, derecho penal, técnicas forenses y manejo de la escena del crimen.',
    exitProfile: 'Técnico preparado para apoyar procesos investigativos y judiciales con técnicas criminalísticas básicas: recolección, clasificación y análisis de evidencias, informes técnicos, cadena de custodia y documentación judicial, actuando con ética, responsabilidad y rigurosidad en entornos de seguridad, justicia e investigación.',
    duration: '3 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['Criminalística', 'Derecho Penal', 'Forense', 'Investigación', 'Evidencias'],
    pensum: [
      'Fundamentos de Seguridad y Salud',
      'Emprendimiento',
      'Conservación del Medio Ambiente',
      'Fundamentos en Criminalística',
      'Derecho Penal',
      'Técnicas de Investigación',
      'Documentología y Grafología',
      'Balística y Fotografía Forense',
      'Materiales Probatorios',
      'Técnica de Procedimiento Judicial',
      'Técnicas de Interrogación',
      'Normativa Técnica Procesal',
      'Metodología de Investigación Criminal',
    ],
    complementary: ['Seminarios cada semestre', 'Prácticas académicas'],
  },
  {
    id: 8,
    category: 'Salud',
    title: 'Técnico Auxiliares en Enfermería',
    description: 'Forma auxiliares capaces de apoyar la atención de pacientes en instituciones de salud: toma de signos vitales, administración de medicamentos, primeros auxilios, cuidado de pacientes crónicos y quirúrgicos, y participación en programas de promoción y mantenimiento de la salud, con un servicio humanizado.',
    objective: 'Formar personal auxiliar competente para brindar cuidados básicos de enfermería, aplicando procedimientos seguros, normas de bioseguridad y la legislación del sistema de salud colombiano, en la atención integral del paciente, la materna, el recién nacido y el paciente crónico.',
    exitProfile: 'Auxiliar de enfermería con bases en anatomía, fisiología, farmacología y fisiopatología, capaz de realizar procedimientos básicos, registrar la historia clínica, apoyar la atención médico-quirúrgica, materno-infantil y de salud mental, y educar al paciente y su familia con trato humanizado.',
    duration: '3 semestres',
    modality: 'Presencial',
    level: 'Técnico Laboral',
    tags: ['Enfermería', 'Salud', 'Primeros Auxilios', 'Farmacología', 'Atención al Paciente'],
    pensum: [
      'Enfermería Básica',
      'Legislación en Salud Pública',
      'Anatomía Humana',
      'Procedimientos Básicos',
      'Primeros Auxilios',
      'Fundamentos de Salud Ocupacional y Gestión Ambiental',
      'Atención al Usuario y Humanización del Servicio de Salud',
      'Fisiología',
      'Programas de Promoción y Mantenimiento de la Salud',
      'Laboratorio Clínico',
      'Materno Infantil',
      'Farmacología',
      'Prácticas Ambulatorias',
      'Médico Quirúrgico',
      'Historia Clínica',
      'Cuidados de Pacientes Crónicos',
      'Salud Mental',
      'Fisiopatología',
    ],
    complementary: ['Prácticas ambulatorias', 'Prácticas académicas'],
    featured: true,
  },
];

const categories = ['Todos', ...Array.from(new Set(programs.map(p => p.category)))];

const Pricing: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState('Todos');
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const [downloadingId, setDownloadingId] = useState<number | null>(null);

  const handleDownloadPDF = async (prog: Program) => {
    setDownloadingId(prog.id);
    try {
      const blob = await pdf(<ProgramPDF program={prog} />).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `CECAP-${prog.title.replace(/\s+/g, '-')}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setDownloadingId(null);
    }
  };

  const filtered = activeCategory === 'Todos'
    ? programs
    : programs.filter(p => p.category === activeCategory);

  const toggleExpand = (id: number) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <div className="pricing-page">
      {/* Header */}
      <div className="pricing-header">
        <span className="pricing-badge">Formación técnica certificada</span>
        <h1 className="pricing-title">Programas y Servicios</h1>
        <p className="pricing-intro">
          Programas técnicos laborales orientados al mercado de La Guajira. Certificación reconocida, docentes activos y horarios flexibles.
        </p>
      </div>

      {/* Filter Tabs */}
      <div className="pricing-filters">
        {categories.map(cat => (
          <button
            key={cat}
            className={`pricing-filter-btn${activeCategory === cat ? ' active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Programs Grid */}
      <div className="pricing-grid">
        {filtered.map(prog => {
          const isExpanded = expandedId === prog.id;
          return (
            <div key={prog.id} className={`program-card${prog.featured ? ' featured' : ''}`}>
              {prog.featured && <div className="program-featured-badge">Destacado</div>}
              <div className="program-card-top">
                <span className="program-category">{prog.category}</span>
                <span className="program-level">{prog.level}</span>
              </div>
              <h3 className="program-title">{prog.title}</h3>

              {/* Contenido intercambiable — misma altura */}
              <div className="program-body">
                <div className={`program-body-face${!isExpanded ? ' active' : ''}`}>
                  <p className="program-description">{prog.description}</p>
                </div>
                <div className={`program-body-face${isExpanded ? ' active' : ''}`}>
                  {prog.objective && (
                    <div className="program-detail-section">
                      <h4 className="program-detail-title">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>
                        Objetivo del Programa
                      </h4>
                      <p className="program-detail-text">{prog.objective}</p>
                    </div>
                  )}
                  {prog.exitProfile && (
                    <div className="program-detail-section" style={{ marginTop: 12 }}>
                      <h4 className="program-detail-title">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/></svg>
                        Perfil de Salida
                      </h4>
                      <p className="program-detail-text">{prog.exitProfile}</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="program-meta">
                <div className="program-meta-item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
                  </svg>
                  {prog.duration}
                </div>
                <div className="program-meta-item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                  {prog.modality}
                </div>
              </div>
              <div className="program-tags">
                {prog.tags.map(tag => (
                  <span key={tag} className="program-tag">{tag}</span>
                ))}
              </div>

              {/* Toggle button */}
              <button
                className="program-expand-btn"
                onClick={() => toggleExpand(prog.id)}
                aria-expanded={isExpanded}
              >
                {isExpanded ? '← Volver a descripción' : 'Ver objetivo y perfil de salida'}
                <svg
                  viewBox="0 0 24 24" fill="currentColor" width="14" height="14"
                  style={{ transform: isExpanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.25s' }}
                >
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
              </button>

              {/* PDF Download */}
              <div className="program-actions">
                <button
                  className="program-pdf-btn"
                  onClick={() => handleDownloadPDF(prog)}
                  disabled={downloadingId === prog.id}
                >
                  <div className="program-pdf-icon">
                    {downloadingId === prog.id ? (
                      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" style={{ animation: 'spin 1s linear infinite' }}>
                        <path d="M12 4V2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8z"/>
                      </svg>
                    ) : (
                      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                        <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"/>
                      </svg>
                    )}
                  </div>
                  <div className="program-pdf-text">
                    <span className="program-pdf-label">
                      {downloadingId === prog.id ? 'Generando PDF...' : 'Plan de estudios completo'}
                    </span>
                    <span className="program-pdf-sub">
                      {downloadingId === prog.id ? 'Por favor espera' : 'Descargar PDF oficial · CECAP'}
                    </span>
                  </div>
                  <svg className="program-pdf-arrow" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M12 16l-6-6h4V4h4v6h4l-6 6zm-6 2h12v2H6v-2z"/>
                  </svg>
                </button>

                <Link to="/contact" className="program-cta">
                  Solicitar información
                  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
                  </svg>
                </Link>
              </div>
            </div>
          );
        })}
      </div>

      {/* Bottom CTA */}
      <div className="pricing-cta-section">
        <h2>¿No encuentras lo que buscas?</h2>
        <p>Contáctanos y diseñamos un plan de formación adaptado a tus necesidades.</p>
        <Link to="/contact" className="pricing-cta-btn">Hablar con un asesor</Link>
      </div>
    </div>
  );
};

export default Pricing;